<template>
  <div
    class="body"
    style="background: radial-gradient(circle, rgba(45,46,47,1) 20%, rgba(111,142,148,1) 100%);padding:12% 35% 20% 35%;height: 100vh!important;"
  >
    <div class="vue-template">
      <form>
        <h3></h3>
        <div class="form-group">
          <label>{{ $t("Кодни киритинг") }}</label> {{min+':'}}<span v-if="sek<10">0</span>{{sek}}
          <input
            type="text"
            ref="focused"
            v-model="code"
            class="form-control form-control-lg"
          />
        </div>

        <button
          type="button"
          class="btn btn-dark btn-lg btn-block"
          @click="Send()"
        >
          {{ $t("Сақлаш") }}
        </button>
        <div class="end">
        <!-- <button type="button" @click="Repeat()">{{ $t("Қайта жўнатиш") }}</button> -->
        </div>
        <p class="forgot-password text-right mt-2 mb-4"></p>
      </form>
    </div>
  </div>
</template>
<style>
.vue-template form {
  padding: 2% 8%;
  border-radius: 10px;
  background: white;
}

.vs__selected-options {
  max-width: 100% !important;
}
</style>

<script>
export default {
  data() {
    return {
      time:180,
      min:0,
      sek:0,
      code:'',
    };
  },
  methods: {
    Focus() {
      if (this.$refs.focused) this.$refs.focused.focus();
    },
    Timer() {
      let self=this;
      setInterval(() => {
        self.time=self.time-1;
          if(self.time>60){
            self.min=parseInt(self.time/60);
            self.sek=self.time-(self.min*60);
          }else if(self.time>0){
            self.min=0
            self.sek=self.time-1;
          }
      }, 1000);
    },
    Repeat() {
      // SMS ni qayta yuborish — backend PROXY orqali (to'g'ridan billing'ga emas).
      let self = this;
      axios
        .get("api/v1/registration/get-sms/" + encodeURIComponent(self.$route.params.code))
        .then(function (response) {
          const d = response.data || {};
          if (d.error === false) {
            self.time = 180;
          } else {
            self.$store.state.errors = d.message || self.$t('no contact with the site');
          }
        })
        .catch(function () {
          self.$store.state.errors = self.$t('no contact with the site');
        });
    },
    Send() {
      // SMS kodni tasdiqlash — backend PROXY /confirm-sms.
      // Backend billing /LoadConfirm ga yuboradi va litsenziya muddatini (datetime1/2)
      // "Mega Stroy" skladiga yozadi. Hosted rejim: per-client IP redirect YO'Q —
      // shu hosted serverda qolib to'g'ridan Login'ga o'tamiz.
      let self = this;
      if (!self.code) {
        self.$store.state.errors = self.$t('Кодни киритинг');
        return;
      }
      axios
        .post("api/v1/registration/confirm-sms", {
          secret_code: self.$route.params.code,
          sms_code: self.code,
          // Billing /LoadConfirm eski shakli — bo'sh string (backend IpPort/token ni o'zi to'ldiradi)
          IpServer: '',
          IpServerMobile: '',
        })
        .then(function (response) {
          const d = response.data || {};
          if (d.error === false) {
            self.$router.push({ name: 'Login' });
          } else {
            self.$store.state.errors = d.message || self.$t('no contact with the site');
          }
        })
        .catch(function () {
          self.$store.state.errors = self.$t('no contact with the site');
        });
    }
  },
  created(){
    this.Timer();
  },
  mounted() {
    this.Focus();
  }
};
</script>
